var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-3 mr-2"},[_c('Dash',{attrs:{"nome_utente_sel":_vm.nome_utente_sel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }